import { render, staticRenderFns } from "./S3.vue?vue&type=template&id=368f16c0&scoped=true&"
import script from "./S3.vue?vue&type=script&lang=js&"
export * from "./S3.vue?vue&type=script&lang=js&"
import style0 from "./S3.vue?vue&type=style&index=0&id=368f16c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f16c0",
  null
  
)

component.options.__file = "S3.vue"
export default component.exports